import React from 'react';
import styles from './root.module.css';

interface Props {
  children: React.ReactNode;
}

export const Root = ({ children }: Props) => {
  return <div className={styles.container}>{children}</div>;
};
